import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Form } from '@elevio/elevio-styles/dist/components/hq';
import FieldRow from '../fieldrow';
import styles from './style.css';

@observer
class CustomForm extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    formStore: PropTypes.shape({
      uploaderStore: PropTypes.shape({
        getFiles: PropTypes.func,
      }).isRequired,
      publicFields: PropTypes.array,
      completion: PropTypes.number.isRequired,
      onChange: PropTypes.func,
      isValidUi: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
      hasGateKeeperEnabled: PropTypes.bool.isRequired,
    }).isRequired,
    settingsStore: PropTypes.shape({
      locales: PropTypes.shape({
        general: PropTypes.shape({
          error: PropTypes.string,
          something_went_wrong: PropTypes.string,
        }),
        modules: PropTypes.shape({
          support: PropTypes.shape({
            add_files: PropTypes.string,
          }),
        }),
      }),
    }).isRequired,
  };

  render() {
    const {
      publicFields,
      uploaderStore: { getFiles },
      isValidUi,
      onChange,
    } = this.props.formStore;

    const {
      locales: {
        modules: {
          support: { add_files: addFilesTranslation },
        },
      },
    } = this.props.settingsStore;
    return (
      <Form className={styles.form} noValidate>
        {publicFields.map(f => (
          <FieldRow
            key={f.id}
            getUploadStore={getFiles}
            // not available in postman stubs, so do not expect any text to
            addFilesTranslation={addFilesTranslation}
            field={f}
            isValidUi={isValidUi}
            onChange={onChange}
          />
        ))}
      </Form>
    );
  }
}

export default observer(CustomForm);



// WEBPACK FOOTER //
// ./src/components/customForm/index.js